<!-- 退款审核 -->
<template>
<el-dialog
      title="退款审核"
      :visible.sync="showModal"
      width="30%"
      :before-close="closeDialog"
    >
      <span class="size18">请确认是否通过此退款审核请求</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleConfirm">同意</el-button>
        <el-button type="danger" @click="handleReject">拒绝</el-button>
      </span>
    </el-dialog>
</template>

<script >
export default {
    props: {
        formData: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            showModal: true
        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        handleConfirm() {
            // this.$message.success('审核已通过！');
            // this.showModal = false;
            this.confirmAudit(1)
        },
        handleReject() {
            this.confirmAudit(2)
            // this.$message.error('审核已拒绝！');
            // this.showModal = false;
        },
        confirmAudit(flag){
            // 1:同意；2：拒绝
            let { tradeId,orderId } = this.formData
            let params = {
                opcode: this.$code.RefundPayAduit,
                i_goods_order: tradeId,
                order: orderId,
                i_flag: flag,
                v_returnof_goods_not: '',
            }
            console.log(params)
            this.$api.requestAPI(params).then(res=>{
                if(res.IsSuccess){
                    let msg = flag === 1 ? '审核已通过！': '审核已拒绝！'
                    
                    if(flag === 1){
                        this.$message.success(msg)
                    }else{
                        this.$message.error(msg)
                    }
                    this.$emit('confirm');
                    this.closeDialog();  
                }else{
                    this.$message.error(res.Message)
                }
            })
        },
        closeDialog(){
            this.$emit('close');
        },       
    }
}
</script>
<style lang='scss' scoped>

</style>


// WEBPACK FOOTER //
// src/views/product/components/refundDialog.vue